import { defineFetch } from 'resift';

const makeGetSourceFileValidationResults = defineFetch({
  displayName: 'Get Source File Validation Results',
  make: (sourceId: string) => ({
    key: [sourceId],
    request: (sourceFileId: string, ignoreErrorsIfMappings?: boolean) => ({ http }) =>
      http({
        method: 'GET',
        route: `/source-files/${sourceFileId}/validation`,
        query: { ignoreErrorsIfMappings },
      }),
  }),
});

export default makeGetSourceFileValidationResults;
